import React from 'react';
import Icon from '../AppIcon';

const ProjectStatusIndicator = ({ status, showLabel = true, size = 'default' }) => {
  const statusConfig = {
    planning: {
      label: 'Planning',
      icon: 'ClipboardList',
      className: 'planning'
    },
    permits: {
      label: 'Permits',
      icon: 'FileCheck',
      className: 'permits'
    },
    construction: {
      label: 'Construction',
      icon: 'HardHat',
      className: 'construction'
    },
    foundation: {
      label: 'Foundation',
      icon: 'Building',
      className: 'construction'
    },
    framing: {
      label: 'Framing',
      icon: 'Layers',
      className: 'construction'
    },
    systems: {
      label: 'Systems',
      icon: 'Zap',
      className: 'permits'
    },
    finishing: {
      label: 'Finishing',
      icon: 'Paintbrush',
      className: 'inspection'
    },
    inspection: {
      label: 'Inspection',
      icon: 'Search',
      className: 'inspection'
    },
    completed: {
      label: 'Completed',
      icon: 'CheckCircle2',
      className: 'completed'
    }
  };

  const config = statusConfig?.[status] || statusConfig?.planning;
  const iconSize = size === 'small' ? 12 : 14;

  return (
    <span className={`project-status-indicator ${config?.className}`}>
      <Icon name={config?.icon} size={iconSize} />
      {showLabel && <span>{config?.label}</span>}
    </span>
  );
};

export default ProjectStatusIndicator;